// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"e84609e6","4402":"f7d2d7b9","5122":"1f3a2121","5912":"aec78970","6480":"e459cfff"}[chunkId] + ".css";
};